import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import ShopForm from '../Form';
import { fetchShop, updateShop } from '@resources/Shop/actions';
import { useIntl } from 'react-intl';
import isEmpty from 'lodash.isempty';

const Update = (props) => {
	const { fetchShop, shop, updateShop, visible, onCancel } = props;
	const intl = useIntl();
	useEffect(() => {
		const fetchData = async () => {
			await fetchShop(visible);
		};
		visible && fetchData();
	}, [fetchShop, visible]);

	const handleSubmit = useCallback(
		(data) => {
			return updateShop(shop._id, data)
				.then((response) => {
					popIn(
						'success',
						intl.formatMessage({
							id: 'message.success.shop.update',
							defaultMessage:
								'An existing Shop entry has been successfully updated',
						})
					);

					onCancel && onCancel();
				})
				.catch((err) => Promise.reject(err));
		},
		[shop]
	);

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.update.shop',
					defaultMessage: 'Update Shop',
				})}
			</Title>
			{!isEmpty(shop) && (
				<ShopForm data={shop} onSubmit={handleSubmit} {...props} />
			)}
		</Modal>
	);
};

const mapStateToProps = ({ shop }) => {
	return {
		shop,
	};
};

export default connect(mapStateToProps, {
	fetchShop,
	updateShop,
})(Update);
